import { useState as t, useEffect as n, useRef as e } from "react";
import r from "@use-it/event-listener";

var u = {},
    c = function c(t, n, e) {
  return u[t] || (u[t] = {
    callbacks: [],
    value: e
  }), u[t].callbacks.push(n), {
    deregister: function deregister() {
      var e = u[t].callbacks,
          r = e.indexOf(n);
      r > -1 && e.splice(r, 1);
    },
    emit: function emit(e) {
      u[t].value !== e && (u[t].value = e, u[t].callbacks.forEach(function (t) {
        n !== t && t(e);
      }));
    }
  };
};

export default function (u, i) {
  if (void 0 === i && (i = global.localStorage), i) {
    var o = function (t) {
      return {
        get: function get(n, e) {
          var r = t.getItem(n);
          return null === r ? "function" == typeof e ? e() : e : JSON.parse(r);
        },
        set: function set(n, e) {
          t.setItem(n, JSON.stringify(e));
        }
      };
    }(i);

    return function (i) {
      return function (u, i, o) {
        var a = o.get,
            f = o.set,
            l = e(null),
            s = t(function () {
          return a(i, u);
        }),
            v = s[0],
            g = s[1];
        return r("storage", function (t) {
          var n = t.key,
              e = JSON.parse(t.newValue);
          n === i && v !== e && g(e);
        }), n(function () {
          return l.current = c(i, g, u), function () {
            l.current.deregister();
          };
        }, []), n(function () {
          f(i, v), l.current.emit(v);
        }, [v]), [v, g];
      }(i, u, o);
    };
  }

  return t;
}